import { Link } from "react-router-dom";
import { Shield, MessageSquare, Code, Handshake, FileCheck } from "lucide-react";
import MarketingFooter from "../components/MarketingFooter";
import MarketingPageShell from "../components/MarketingPageShell";
import usePageMeta from "../hooks/usePageMeta";

const AREAS = [
  { icon: Shield, t: "Fraud operations", d: "Investigate edge-case claims, build fraud rules, run the SIU queue." },
  { icon: MessageSquare, t: "Claims support", d: "Be the friendly face merchants meet on WhatsApp when things go wrong." },
  { icon: Code, t: "Engineering", d: "Build the cyber-cover engine, FlashClaim pipeline, and the merchant dashboard." },
  { icon: Handshake, t: "Partnerships", d: "Onboard banks, PSPs, and merchant networks across East and West Africa." },
  { icon: FileCheck, t: "Compliance", d: "Own the IRA alignment, policy wording, KYC frameworks, and audit trails." },
];

export default function Careers() {
  usePageMeta({
    title: "Careers at Fortiqa",
    description:
      "Build embedded cyber insurance for African merchants. Hiring across fraud ops, claims, engineering, partnerships, and compliance.",
  });
  return (
    <div className="min-h-screen bg-[#f4f2eb] text-[#1b1d1c]" data-testid="careers-page">
      <MarketingPageShell
        eyebrow="Careers"
        title="Build the safety layer for African commerce."
        intro="We're a small team in Nairobi (with remote talent across the continent). Hiring in five areas — and always listening for outstanding humans we should know about."
        testid="careers"
      >
        <section className="px-6 lg:px-10 max-w-7xl mx-auto pb-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {AREAS.map(({ icon: Icon, t, d }) => (
            <div
              key={t}
              className="rounded-2xl bg-white border border-[#114232]/10 p-6 hover:border-[#114232]/30 hover:shadow-md transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-[#114232]/8 grid place-items-center mb-4">
                <Icon className="w-5 h-5 text-[#114232]" strokeWidth={1.7} />
              </div>
              <div className="font-heading text-base font-bold text-[#114232] mb-1.5">{t}</div>
              <p className="text-sm text-[#5c6360] leading-relaxed">{d}</p>
            </div>
          ))}
        </section>

        <section className="px-6 lg:px-10 max-w-7xl mx-auto pb-24">
          <div className="rounded-2xl bg-white border border-[#114232]/10 p-8 lg:p-10">
            <div className="font-heading text-2xl font-bold text-[#114232] mb-3">
              Join the team
            </div>
            <p className="text-sm text-[#5c6360] leading-relaxed mb-5 max-w-2xl">
              Send a short note about who you are, what you've built, and the kind of role
              you're looking for. We screen open applications weekly.
            </p>
            <a
              href="mailto:careers@fortiqa.co.ke?subject=Join%20the%20team"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#c15337] hover:bg-[#a8472f] text-white text-sm font-semibold transition-all shadow-md hover:shadow-lg"
              data-testid="careers-cta-email"
            >
              Join the team
            </a>
          </div>
        </section>
      </MarketingPageShell>
      <MarketingFooter />
    </div>
  );
}
